import React, { useState, useEffect, useContext } from "react";
import { useParams, useHistory } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";

import MessageInput from "../../components/MessageInputCustom/";
import TicketHeader from "../../components/TicketHeader";
import TicketInfo from "../../components/TicketInfo";
import TicketActionButtons from "../../components/TicketActionButtonsCustom";
import TicketActionButtonsCustomDynamics from "../../components/TicketActionButtonsCustomDynamics";
import MessagesList from "../../components/MessagesList";
import api from "../../services/api";
import { ReplyMessageProvider } from "../../context/ReplyingMessage/ReplyingMessageContext";
import toastError from "../../errors/toastError";
import { AuthContext } from "../../context/Auth/AuthContext";
import { TagsContainer } from "../../components/TagsContainer";
import { SocketContext } from "../../context/Socket/SocketContext";
import ContactDrawer from "../../components/ContactDrawer";


const useStyles = makeStyles(theme => ({
  container: {
    width: "100vw",
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    boxSizing: "border-box",
    overflow: "hidden"
  },

  chatContainer: {
    flex: 1,
    // backgroundColor: "#eee",
    padding: theme.spacing(4),
    height: `calc(100% - 48px)`,
    overflowY: "hidden",
  },
  chatPapper: {
    // backgroundColor: "red",
    display: "flex",
    height: "100%",
  },

  contactsWrapper: {
    display: "flex",
    height: "100%",
    flexDirection: "column",
    overflowY: "hidden",
  },
  messagessWrapper: {
    display: "flex",
    height: "100%",
    width: "100%",
    overflow: "hidden",
    justifyContent: "space-between",
    flexDirection: "column",
  },
  welcomeMsg: {
    backgroundColor: theme.palette.boxticket,
    display: "flex",
    justifyContent: "space-evenly",
    alignItems: "center",
    height: "100%",
    textAlign: "center",
  },
  paper: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
  },
}));

const ChatDynamics = () => {
  const { ticketId } = useParams();
  const history = useHistory();
  const classes = useStyles();

  const { user } = useContext(AuthContext);

  const [drawerOpen, setDrawerOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [contact, setContact] = useState({});
  const [ticket, setTicket] = useState({});

  const valorTicketFixo = localStorage.getItem("ticket_uuid");
  const socketManager = useContext(SocketContext);

  useEffect(() => {
    setLoading(true);
    const delayDebounceFn = setTimeout(() => {
      const fetchTicket = async () => {
        try {

          const { data } = await api.get("/tickets/u/" + valorTicketFixo);
          const { queueId } = data;
          const { queues, profile } = user;

          const queueAllowed = queues.find((q) => q.id === queueId);
          console.log("ver o valor de queueAloowed ", queueAllowed)

          setContact(data.contact);
          setTicket(data);
          setLoading(false);
        } catch (err) {
          setLoading(false);
          toastError(err);
        }
      };
      fetchTicket();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [ticketId, user, history]);

  useEffect(() => {
    // Define o overflow como hidden ao montar o componente
    document.body.style.overflow = "hidden";
  
    // Limpa o estilo ao desmontar o componente
    return () => {
      document.body.style.overflow = ""; // Restaura o estilo padrão
    };
  }, []); // Executa apenas ao montar e desmontar  

  useEffect(() => {
    const companyId = localStorage.getItem("companyId");
    const socket = socketManager.getSocket(companyId);

    socket.on("ready", () => socket.emit("joinChatBox", `${ticket.id}`));

    console.log("console do ticket ", ticket);

    if (ticket.status === 'closed') {
      api.put(`/tickets/${ticket.id}`, {
				status: 'open',
				userId: ticket.userId || null,
				useIntegration: ticket.status === "closed" ? false : ticket.useIntegration,
				promptId: ticket.status === "closed" ? false : ticket.promptId,
				integrationId: ticket.status === "closed" ? false : ticket.integrationId        
      })
    }

    socket.on(`company-${companyId}-ticket`, (data) => {
      if (data.action === "update" && data.ticket.id === ticket.id) {
        setTicket(data.ticket);
        // history.push("/");
      }

      if (data.action === "delete" && data.ticketId === ticket.id) {
        // toast.success("Ticket deleted sucessfully.");
        history.push("/");
      }
    });

    socket.on(`company-${companyId}-contact`, (data) => {
      if (data.action === "update") {
        setContact((prevState) => {
          if (prevState.id === data.contact?.id) {
            return { ...prevState, ...data.contact };
          }
          return prevState;
        });
      }
    });

    return () => {
      socket.disconnect();
    };
  }, [ticketId, ticket, history, socketManager]);


  const handleDrawerOpen = () => {
    setDrawerOpen(true);
  };

  const handleDrawerClose = () => {
    setDrawerOpen(false);
  };

  const renderTicketInfo = () => {
    console.log('ver o renderticketinfo ', ticket.user)
    console.log('ver o renderticketinfo2 ', ticket)
    if (ticket.user !== undefined) {
      return (
        <TicketInfo
          contact={contact}
          ticket={ticket}
          onClick={handleDrawerOpen}
        />
      );
    }
  };

  const renderMessagesList = () => {
    return (
      <>
        <MessagesList
          ticket={ticket}
          ticketId={ticket.id}
          isGroup={ticket.isGroup}
        ></MessagesList>
        <MessageInput ticketId={ticket.id} ticketStatus={ticket.status} />
      </>
    );
  };  
  

  return (
    <div className={classes.container}>
      <Grid item xs={12} className={classes.messagessWrapper}>
        {valorTicketFixo ? (
          <>
          <Paper
            variant="outlined"
            elevation={0}
            className={classes.paper}
          >
            <TicketHeader loading={loading}>
              {renderTicketInfo()}
              <TicketActionButtonsCustomDynamics ticket={ticket} />
            </TicketHeader>
            <Paper>
              <TagsContainer ticket={ticket} />
            </Paper>
            <ReplyMessageProvider>{renderMessagesList()}</ReplyMessageProvider>
          </Paper>
          <ContactDrawer
            open={drawerOpen}
            handleDrawerClose={handleDrawerClose}
            contact={contact}
            loading={loading}
            ticket={ticket}
          />
          </>
        ): (
          <>
          <p>teste</p>
        </>
        )}
      </Grid>
     </div>
  );
};

export default ChatDynamics;
